<router-outlet *ngIf="!loading"> </router-outlet>
